(ns frontend.mobile-utils)

(defn hide-keyboard []
  (.blur (.-activeElement js/document)))
